import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=482b36fd"
import script from "./Index.js?vue&type=script&lang=js&external"
export * from "./Index.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports